export default {"src":"/_next/static/media/table.4955c411.svg","height":100,"width":100};